export default __webpack_public_path__ + "static/media/ADAMS.e6f0d865.png";